const defaultFormatOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
};

export const formatPublishDate = (date, options = defaultFormatOptions) =>
  new Date(date).toLocaleString('en-US', options);
